// extracted by mini-css-extract-plugin
var _1 = "_rolesCreateRoleForm-module__button-container";
var _2 = "_rolesCreateRoleForm-module__button-subcontainer";
var _3 = "_rolesCreateRoleForm-module__checkbox";
var _4 = "_rolesCreateRoleForm-module__container";
var _5 = "_rolesCreateRoleForm-module__form-container";
var _6 = "_rolesCreateRoleForm-module__form-subcontainer";
var _7 = "_rolesCreateRoleForm-module__role-name-input";
var _8 = "_rolesCreateRoleForm-module__span-2";
export { _1 as "button-container", _2 as "button-subcontainer", _3 as "checkbox", _4 as "container", _5 as "form-container", _6 as "form-subcontainer", _7 as "role-name-input", _8 as "span-2" }
